var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-window mt-3 mr-3 border bd-e4 px-3"},[_c('HeaderWindow',{attrs:{"title":_vm.title,"show_calll":true},on:{"onClose":_vm.onClose}}),_c('ResultTable',{attrs:{"list_results":_vm.list_results,"documents":_vm.documents},on:{"getResultsByDiseases":_vm.getResultsByDiseases}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }